import React from 'react';
import { stateTypes } from './enums';

const LeaderboardWidgetCellTitle = ({ state, titleText, topPlayersToShowState }) => {
    return (
        <div className={`leaderboard-widget__cell is-title is-${state.id}`}>
            {state.textTitle}
            {
                state.id === stateTypes.POSITION &&
                <div className="leaderboard-widget__title-text">
                    {
                        topPlayersToShowState &&
                        <span className="leaderboard-widget__top-players-to-show">top</span>
                    }
                    <span>{titleText}</span>
                </div>
            }
        </div>
    );
};

export default LeaderboardWidgetCellTitle;
